export interface AiConversationCreationOptions {
    parameters?: Record<string, unknown>;
    expirationInSec?: number;
}
